import styled, { keyframes } from "styled-components";

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const PdfWrapper = styled.div`
  margin: 8px 0;
  animation: ${slideUp} 0.4s ease both;

  .container {
    .pdf-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #ffffff;
      border: 1.5px solid #e4ece8;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(21, 82, 61, 0.07);
      transition: box-shadow 0.3s ease, transform 0.3s ease;

      &:hover {
        box-shadow: 0 8px 32px rgba(21, 82, 61, 0.14);
        transform: translateY(-2px);
      }

      .left-content {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: 1;
        padding: 18px 28px;

        .pdf-icon-wrap {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: linear-gradient(135deg, #15523d, #1e7a58);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(21, 82, 61, 0.25);
        }

        .text-wrap {
          display: flex;
          flex-direction: column;
          gap: 2px;

          .label {
            font-family: "Montserrat", sans-serif;
            font-size: 13px;
            font-weight: 600;
            color: #888;
            text-transform: uppercase;
            letter-spacing: 0.8px;
          }

          .filename {
            font-family: "Montserrat", sans-serif;
            font-size: 15px;
            font-weight: 600;
            color: #1a3328;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 500px;
          }
        }
      }

      .right-pdf {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0 28px;
        height: 80px;
        background: transparent;
        border-left: 1.5px solid #e4ece8;
        color: #15523d;
        font-family: "Montserrat", sans-serif;
        font-size: 13px;
        font-weight: 700;
        text-decoration: none;
        letter-spacing: 0.5px;
        transition: background 0.3s ease, color 0.3s ease;
        white-space: nowrap;

        svg path, svg polyline, svg line {
          transition: stroke 0.3s ease;
        }

        &:hover {
          background: linear-gradient(135deg, #15523d, #1e7a58);
          color: #fff;
          border-left-color: transparent;

          svg path,
          svg polyline,
          svg line {
            stroke: #fff;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 900px) {
    .container .pdf-box {
      .left-content {
        padding: 14px 20px;

        .text-wrap .filename {
          font-size: 13px;
          max-width: 300px;
        }
      }

      .right-pdf {
        padding: 0 20px;
        font-size: 12px;
        height: 68px;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    .container .pdf-box {
      border-radius: 12px;

      .left-content {
        padding: 12px 14px;
        gap: 10px;

        .pdf-icon-wrap {
          width: 36px;
          height: 36px;
          border-radius: 10px;
        }

        .text-wrap .label {
          display: none;
        }

        .text-wrap .filename {
          font-size: 12px;
          max-width: 180px;
        }
      }

      .right-pdf {
        padding: 0 14px;
        height: 60px;
        font-size: 11px;
        gap: 4px;
      }
    }
  }
`;
